import React from 'react'
import BlockBuilder from '../../components/BlockBuilder'
import blockKeys from '../../topics/blocks'

const Block = (props) => <BlockBuilder blocks={blockKeys} {...props} />

export default Block
